export class RegexUtils {
    static concat = (regExps, flags) => {
        return RegExp(regExps.reduce((acc, cur) => acc + cur.source, ""), flags);
    };
    static or = (regExps, flags) => {
        return RegExp(`(?:${regExps.map((r) => r.source).join("|")})`, flags);
    };
    static repeat = (regExp, sign) => {
        return RegExp(`(?:${regExp.source})${sign}`);
    };
}
//# sourceMappingURL=regex-utils.js.map